import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Dauert’s doch was länger/ kürzer?',
  text: {
    [OrderMethod.Pickup]:
      'Erwartete Abholzeit: <strong>{{date}}</strong> um <strong>{{time}}</strong><br/> Bei Bedarf kannst du die Zeit hier ändern.',
    [OrderMethod.OnSite]:
      'Der Kunde erwartet die Bestellung an seinem Platz: <strong>{{table}}</strong><br/><strong>{{date}}</strong> um <strong>{{time}}</strong><br/> Falls nötig, kannst du die Zeit hier ändern.',
    // A table order whose table the backend could not name.
    on_site_without_table:
      'Der Kunde erwartet die Bestellung an seinem Platz<br/><strong>{{date}}</strong> um <strong>{{time}}</strong><br/> Falls nötig, kannst du die Zeit hier ändern.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'Erwartete Lieferzeit: <strong>{{date}}</strong> um <strong>{{time}}</strong><br/> Bei Bedarf kannst du die Zeit hier ändern.',
      [DeliveryMode.External]: 'Der Fahrer wird die Bestellung um <strong>{{time}}{{confidenceLabel}}</strong> abholen',
    },
  },
  labels: {
    today: 'Heute',
  },
  confidence_labels: {
    estimated: ' (geschätzt!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Neue Abholzeit Bestätigen',
    confirm_on_site: 'Neue Servierzeit bestätigen',
    confirm_delivery: 'Neue Lieferzeit bestätigen',
  },
  confirmation_modal: {
    description: 'Bist du sicher, dass du die Zeit von {{currentPickupTime}} auf {{newPickupTime}} ändern willst?',
    ok_button_text: 'Neue Zeit bestätigen',
    cancel_button_text: 'Nein, zurück zur vorherigen Zeit',
  },
};
